// Mock data for LISTING AiGENT website

export const brand = {
  name: 'LISTING AiGENT',
  legal: 'LISTING AiGENT LLC',
  tagline: 'Your AI assistant for showings, calls & listings.',
  email: 'contact@listingaigent.com',
  address: '2108 N St, Suite #18130, Sacramento, CA 95816',
  domain: 'listingaigent.com',
};

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Features', to: '/features' },
  { label: 'How it works', to: '/how-it-works' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Contact', to: '/contact' },
];

export const features = [
  {
    icon: 'PhoneCall',
    title: 'AI Call Answering',
    desc: 'Never miss a lead. Your AiGENT answers buyer and seller calls 24/7 with natural conversation.',
  },
  {
    icon: 'Home',
    title: 'Listing Q&A',
    desc: 'Instantly answers questions about square footage, features, price history and neighborhood details.',
  },
  {
    icon: 'CalendarCheck',
    title: 'Auto Scheduling',
    desc: 'Books private showings and open house appointments directly into your calendar without back-and-forth.',
  },
  {
    icon: 'Sparkles',
    title: 'One-Click Listing Import',
    desc: 'Paste any Zillow, Redfin, or Realtor URL and the AiGENT extracts every detail in seconds.',
  },
  {
    icon: 'MessageSquare',
    title: 'SMS Follow-ups',
    desc: 'Sends warm, on-brand text follow-ups to nurture leads while you focus on closing.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Compliance Ready',
    desc: 'Fair housing aware, TCPA compliant, and built with realtor code of ethics in mind.',
  },
];

export const steps = [
  {
    num: '01',
    title: 'Add Your Listings',
    desc: 'Paste a Zillow, Redfin or Realtor URL — or type the address. Your AiGENT pulls in photos, price and details automatically.',
  },
  {
    num: '02',
    title: 'Assign a Phone Number',
    desc: 'Get a dedicated local number for each listing or use one hub number. Route calls straight to the AiGENT.',
  },
  {
    num: '03',
    title: 'Let AiGENT Take Over',
    desc: 'The AiGENT answers calls, qualifies leads, answers listing questions and books showings on your calendar.',
  },
  {
    num: '04',
    title: 'Close More Deals',
    desc: 'You get transcripts, lead summaries, and warm handoffs. Focus on closings — leave the phone tag to AI.',
  },
];

export const stats = [
  { value: '24/7', label: 'Call coverage' },
  { value: '<3s', label: 'Response time' },
  { value: '10x', label: 'Faster lead capture' },
  { value: '100%', label: 'Calls transcribed' },
];

export const testimonials = [
  {
    quote: 'LISTING AiGENT caught three leads on a Sunday while I was at an open house. Two became showings by Tuesday.',
    name: 'Marcus R.',
    role: 'Realtor, Sacramento CA',
  },
  {
    quote: 'It sounds like a real assistant. Buyers get their questions answered instantly and I only get warm handoffs.',
    name: 'Priya S.',
    role: 'Broker Associate, Austin TX',
  },
  {
    quote: 'Import from Zillow, hand off to AI, wake up to booked showings. This is the future of the business.',
    name: 'Jordan L.',
    role: 'Team Lead, Miami FL',
  },
];

export const faqs = [
  {
    q: 'How does the 7-day trial work?',
    a: 'A one-time $10 activation fee unlocks full access to LISTING AiGENT for 7 days. After the trial, your subscription automatically renews at $100/month until you cancel. Cancel anytime before the trial ends and you won\'t be charged the monthly fee.',
  },
  {
    q: 'Do I need any special equipment?',
    a: 'No. LISTING AiGENT runs on your iPhone or Android. All you need is your existing phone and an internet connection.',
  },
  {
    q: 'Can the AiGENT sound like me?',
    a: 'Yes. You can pick from natural voices and customize tone, greeting, and how the AiGENT introduces your brokerage.',
  },
  {
    q: 'Is my data safe?',
    a: 'Yes. All calls, transcripts and lead data are encrypted at rest and in transit. We never sell your data. See our Privacy Policy for details.',
  },
  {
    q: 'Is it compliant with fair housing and TCPA?',
    a: 'The AiGENT is designed to avoid discriminatory language, honor consent, and follow fair housing guidance. You retain full call transcripts.',
  },
];

export const images = {
  // Local WebP backdrops — served from our own domain so we're not depending
  // on Pexels' CDN uptime or cache eviction. Convert new backdrops with
  // scripts/postbuild-static-routes.js-style PIL pipeline.
  heroBg:           '/marketing/backdrops/hero-estate.webp',
  heroBgAlt:        '/marketing/backdrops/hero-estate-alt.webp',
  realtorPhone:     '/marketing/backdrops/realtor-phone.webp',
  realtorClipboard: '/marketing/backdrops/realtor-clipboard.webp',
  interior1:        '/marketing/backdrops/interior-1.webp',
  interior2:        '/marketing/backdrops/interior-2.webp',
};
